<template>
  <div class="awards-tile" v-if="$store.getters.getSuggestedRewards.length">
    <div class="title-cnt">
      <h6 class="title primary">{{ $t("Premi") }}</h6>
      <router-link class="title-link primary" to="/catalog">{{
        $t("Vai al catalogo")
      }}</router-link>
    </div>
    <div class="slides">
      <swiper :options="swiperOption">
        <swiper-slide
          v-for="item in $store.getters.getSuggestedRewards"
          :key="item.id"
        >
          <div class="slide" @click="navigate(item)">
            <div class="image">
              <img :src="item.image || 'https://via.placeholder.com/150x150'" />
            </div>
            <div class="content">
              <h6 class="adwerb-title">{{ item.title }}</h6>
              <p class="adwerb-desc">{{ item.description }}</p>
              <div
                class="progress-cnt"
                v-if="$store.getters.getUser.coins <= item.cost"
              >
                <div class="progress-cnt__progress">
                  <Progress
                    class="awards-tile__progress"
                    :value="progressValue(item)"
                    rounded
                  />
                </div>
                <p class="progress-val">
                  <span class="primary">{{
                    $store.getters.getUser.coins
                  }}</span>
                  <span class="primary"> /{{ item.cost }} coins </span>
                </p>
              </div>
              <div v-else>
                <p class="progress-val primary">
                  {{ $t("Puoi riscattare il premio!") }}
                </p>
              </div>
            </div>
          </div>
          <p class="link">
            <router-link :to="`catalog/rewards?rewardId=${item.id}`">{{
              $t("Vai al prodotto")
            }}</router-link>
          </p>
        </swiper-slide>
      </swiper>
    </div>
    <div class="swiper-pagination" slot="pagination"></div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Progress from "./common/Progress";

export default {
  name: "AwardsTile",
  components: {
    swiper,
    swiperSlide,
    Progress
  },
  data() {
    return {
      swiperOption: {
        spaceBetween: 20,
        speed: 500,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        }
      }
    };
  },
  methods: {
    navigate(el) {
      if (this.$store.getters.isMobile) {
        this.$router.push(`/catalog/rewards?rewardId=${el.id}`);
      }
    },
    progressValue(item) {
      return (
        (this.$store.getters.getUser.coins / item.cost > 1
          ? 1
          : this.$store.getters.getUser.coins / item.cost) * 100
      );
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0;
}

.awards-tile {
  position: relative;
}
.slides {
  border-radius: 5px;
  overflow: hidden;
}
::v-deep .swiper-slide {
  background-color: transparent;
  transition: 0.5s all;
  opacity: 0.6;
}
::v-deep .swiper-slide.swiper-slide-active {
  background-color: #fff;
  opacity: 1;
}
::v-deep .swiper-pagination {
  right: 0;
  display: none;
  @media (min-width: 767px) {
    display: block;
  }
}

::v-deep .swiper-pagination-bullet {
  margin: 0 5px;
  &:last-of-type {
    margin-right: 0px;
  }

  &.swiper-pagination-bullet-active {
    background: #000000;
    height: 10px;
    width: 10px;
  }
}

.slide {
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 5px;
  padding: 20px 10px 0 25px;
}

.content {
  flex-grow: 1;
}
.image {
  min-width: 60px;
  max-width: 60px;
  height: 60px;
  overflow: hidden;
  margin-right: 20px;

  ::v-deep img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
}

.adwerb-title {
  line-height: 2;
  font-weight: bold;
  margin-bottom: 0;
  font-size: inherit;
}
.adwerb-desc {
  margin-bottom: 10px;
}
.progress-cnt {
  display: flex;
  align-items: center;
}
.progress {
  flex-grow: 1;
  margin-bottom: 0;
  // background: #cebbf7;
}

.progress-val {
  margin-left: 10px;
  font-size: 14px;
  span {
    font-weight: bold;
  }
}

.link {
  display: none;
  @media (min-width: 767px) {
    display: flex;
    justify-content: flex-end;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 10px;
    margin-right: 10px;
  }
}

@media (max-width: 767px) {
  ::v-deep .swiper-wrapper {
    display: flex;
    text-align: center;
    box-sizing: border-box;

    &::-webkit-scrollbar {
      display: none;
    }
  }
  ::v-deep .swiper-slide {
    height: unset;
    background-color: #fff;
    opacity: 1;
    display: flex;
  }
  .slide {
    padding: 15px;
    flex-direction: column;
    align-items: center;
  }
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .progress-cnt {
    flex-wrap: wrap;
    margin-top: auto;
  }
  .adwerb-desc {
    justify-self: flex-end;
  }

  .progress-val {
    margin-left: auto;
  }
  .image {
    margin-right: 0;
  }
}
.progress-cnt__progress {
  flex-grow: 1;
}
.swiper-container {
  background-color: transparent;
  border-radius: 5px;
}
</style>
